import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

interface CollectionsRecalledFilterProps {
  filterIndex: number;
}

/**
 * Renders radio buttons for filtering sessions by collections recalled status
 */
export const CollectionsRecalledFilter = ({ filterIndex }: CollectionsRecalledFilterProps) => {
  const { t } = useTranslation();
  const { control, getValues } = useFormContext();

  const { update } = useFieldArray({ control, name: 'filters' });

  const hasCollection = useWatch({ control, name: `filters.${filterIndex}.hasCollection` });

  const handleChange = (value: string) => {
    let booleanValue: boolean | null;
    if (value === 'true') {
      booleanValue = true;
    } else if (value === 'false') {
      booleanValue = false;
    } else {
      booleanValue = null; // 'all' option
    }
    const currentFilter = getValues(`filters.${filterIndex}`);
    update(filterIndex, { ...currentFilter, hasCollection: booleanValue });
  };

  return (
    <div className="space-y-3">
      <RadioGroup
        value={hasCollection?.toString() || ''}
        onValueChange={handleChange}
        className="gap-0"
      >
        <div className="flex items-center space-x-2 rounded-sm px-2 py-1.5 hover:bg-selected-soft">
          <RadioGroupItem value="true" id={`recalled-true-${filterIndex}`} />
          <Label htmlFor={`recalled-true-${filterIndex}`} className="cursor-pointer font-normal">
            {t('analytics.filters.recalledCollections')}
          </Label>
        </div>
        <div className="flex items-center space-x-2 rounded-sm px-2 py-1.5 hover:bg-selected-soft">
          <RadioGroupItem value="false" id={`recalled-false-${filterIndex}`} />
          <Label htmlFor={`recalled-false-${filterIndex}`} className="cursor-pointer font-normal">
            {t('analytics.filters.didNotRecallCollections')}
          </Label>
        </div>
      </RadioGroup>
    </div>
  );
};
